import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import ViewTrainingClass from "../view";
import ViewClassModule from "./view";
import EditClassModule from "./edit";
import { MODULE_TRAINING_CLASS } from "variables/constants";

const classModuleRoutes = [
	generateCRUDRoutes({
		mainTitle: "Course Modules",
		basePath: "training-classes/:classeId/training-class-modules",
		mainComponent: <ViewTrainingClass />,
	    layout: "/console",	   
	    subTitle:"Class Modules",
	    viewComponent: <ViewClassModule />,
	    createComponent: <EditClassModule />,
	    editComponent: <EditClassModule />,
		level:3,
		moduleId: MODULE_TRAINING_CLASS,  
			

	})
]

export default classModuleRoutes;